import React from 'react';
import PropType from 'prop-types';
import { useNavigate } from 'react-router-dom';

import './ProformaInvoice.css';

class ProformaInvoiceClass extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      invoice: this.props.invoice,
      CreateExcessInvoicePDF: this.props.CreateExcessInvoicePDF,
      currentStatus: this.props.currentStatus,
    };
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    this.setState({
      invoice: newProps.invoice,
      CreateExcessInvoicePDF: newProps.CreateExcessInvoicePDF,
      currentStatus: newProps.currentStatus,
    });
    let regex = /id="EICustomerName">.*<\/td>/;
    let tmpVal = newProps.invoice.match(regex);
    if (tmpVal != null) {
      tmpVal = tmpVal[0].replace(/id="EICustomerName">/, '').replace(/<\/td>/, '');
      const nameInput = document.getElementById('nameInput');
      if (nameInput) {
        nameInput.value = tmpVal.trim();
      }
    }
    regex = /id="EIAddress">((?!<)(.|\r\n))*<\/td>/;
    tmpVal = newProps.invoice.match(regex);
    if (tmpVal != null) {
      tmpVal = tmpVal[0].replace(/id="EIAddress">/, '').replace(/<\/td>/, '');
      const addressInput = document.getElementById('addressInput');
      if (addressInput) {
        addressInput.value = tmpVal.trim();
      }
    }
  }

  changeName = () => {
    const nameInput = document.getElementById('nameInput');
    const nameDisplay = document.getElementById('EICustomerName');
    if (nameInput && nameDisplay) {
      nameDisplay.innerText = nameInput.value;
    }
  };

  changeAddress = () => {
    const addressInput = document.getElementById('addressInput');
    const addressDisplay = document.getElementById('EIAddress');
    if (addressInput && addressDisplay) {
      addressDisplay.innerText = addressInput.value;
    }
  };

  handleSave = () => {
    const nameInput = document.getElementById('nameInput');
    const addressInput = document.getElementById('addressInput');
    const invoiceForm = document.getElementById('InvoiceForm');
    const invoiceDisplay = document.getElementById('InvoiceDisplay');
    const saveNotice = document.getElementById('SaveNotice');

    if (nameInput && addressInput) {
      this.state.CreateExcessInvoicePDF(
        nameInput.value.trim(),
        addressInput.value.trim(),
      );
    }

    if (invoiceForm) invoiceForm.hidden = true;
    if (invoiceDisplay) invoiceDisplay.hidden = true;
    if (saveNotice) saveNotice.hidden = false;

    setTimeout(() => {
      this.props.navigate('/');
    }, 5000);
  };

  render() {
    if (this.state.currentStatus > 3) {
      this.props.navigate('/');
      return null;
    }
    return (
      <div className="col-xs-12" id="proforma-invoice">
        <h4 className="text-left">Generate Proforma Invoice</h4>
        <form>
          <div className="form-group" id="InvoiceForm">
            <label htmlFor="nameInput">
              Name:
              <input
                type="text"
                className="form-control"
                id="nameInput"
                placeholder="Name"
                onChange={this.changeName}
              />
            </label>
            <br />
            <label htmlFor="addressInput">
              Address:
              <textarea
                className="form-control"
                id="addressInput"
                placeholder="Address"
                onChange={this.changeAddress}
              />
            </label>
            <br />
            <button
              className="btn btn-success btn-toolbar"
              type="button"
              id="btnEISubmit"
              onClick={this.handleSave}
            >
              Save
            </button>
          </div>
          <div className="alert alert-success" role="alert" id="SaveNotice" hidden>
            Thank you for your payment.
            <br />
            The Invoice will be delivered by the Fitter during the allocated fitment date and time.
          </div>
        </form>
        <div className="row" id="InvoiceDisplay">
          <div
            className="col-xs-12"
            dangerouslySetInnerHTML={{ __html: this.state.invoice }}
          />
        </div>
      </div>
    );
  }
}

ProformaInvoiceClass.propTypes = {
  invoice: PropType.string,
  CreateExcessInvoicePDF: PropType.func,
  navigate: PropType.func.isRequired,
  currentStatus: PropType.number,
};

ProformaInvoiceClass.defaultProps = {
  invoice: '<p>Loading</p>',
  CreateExcessInvoicePDF: null,
  currentStatus: 0,
};

function ProformaInvoice(props) {
  const navigate = useNavigate();
  return <ProformaInvoiceClass {...props} navigate={navigate} />;
}

export default ProformaInvoice;
